import React from "react";
import {IconSource} from "../../../shared/enums/iconSource";
import Icon from "../common/icon/icon";
import "./banner.sass";
import parse from "html-react-parser";

export interface IBannerProps {
  text: string;
  enableMarkup?: boolean;
  icon?: IconSource;
}

const Banner: React.FC<IBannerProps> = ({text, icon, enableMarkup}) => {
  return (
    <div className="banner">
      {icon && <Icon source={icon} />}
      {enableMarkup ? <div>{parse(text)}</div> : <div>{text}</div>}
    </div>
  );
};

export default Banner;
